let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fOpTU")).then(() => parcelRequire('cKmrZ'));